/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentBaseResponse } from './GetAppointmentBaseResponse';
import {
    GetAppointmentBaseResponseFromJSON,
    GetAppointmentBaseResponseFromJSONTyped,
    GetAppointmentBaseResponseToJSON,
    GetAppointmentBaseResponseToJSONTyped,
} from './GetAppointmentBaseResponse';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetTimeEntryTypeBaseResponse } from './GetTimeEntryTypeBaseResponse';
import {
    GetTimeEntryTypeBaseResponseFromJSON,
    GetTimeEntryTypeBaseResponseFromJSONTyped,
    GetTimeEntryTypeBaseResponseToJSON,
    GetTimeEntryTypeBaseResponseToJSONTyped,
} from './GetTimeEntryTypeBaseResponse';

/**
 * 
 * @export
 * @interface GetPayrollLedgerEntryResponse
 */
export interface GetPayrollLedgerEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPayrollLedgerEntryResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPayrollLedgerEntryResponse
     */
    approvalDate: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetPayrollLedgerEntryResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetPayrollLedgerEntryResponse
     */
    workDate: Date;
    /**
     * 
     * @type {number}
     * @memberof GetPayrollLedgerEntryResponse
     */
    totalHours: number;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetPayrollLedgerEntryResponse
     */
    hourlyRate: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetPayrollLedgerEntryResponse
     */
    amount: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPayrollLedgerEntryResponse
     */
    approvedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetPayrollLedgerEntryResponse
     */
    approvedBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPayrollLedgerEntryResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetPayrollLedgerEntryResponse
     */
    updatedAt: Date | null;
    /**
     * 
     * @type {GetTimeEntryTypeBaseResponse}
     * @memberof GetPayrollLedgerEntryResponse
     */
    timeEntryType: GetTimeEntryTypeBaseResponse | null;
    /**
     * 
     * @type {GetAppointmentBaseResponse}
     * @memberof GetPayrollLedgerEntryResponse
     */
    appointment: GetAppointmentBaseResponse | null;
}

/**
 * Check if a given object implements the GetPayrollLedgerEntryResponse interface.
 */
export function instanceOfGetPayrollLedgerEntryResponse(value: object): value is GetPayrollLedgerEntryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('approvalDate' in value) || value['approvalDate'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('workDate' in value) || value['workDate'] === undefined) return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined) return false;
    if (!('hourlyRate' in value) || value['hourlyRate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('approvedAt' in value) || value['approvedAt'] === undefined) return false;
    if (!('approvedBy' in value) || value['approvedBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('timeEntryType' in value) || value['timeEntryType'] === undefined) return false;
    if (!('appointment' in value) || value['appointment'] === undefined) return false;
    return true;
}

export function GetPayrollLedgerEntryResponseFromJSON(json: any): GetPayrollLedgerEntryResponse {
    return GetPayrollLedgerEntryResponseFromJSONTyped(json, false);
}

export function GetPayrollLedgerEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayrollLedgerEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'approvalDate': (new Date(json['approvalDate'])),
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'workDate': (new Date(json['workDate'])),
        'totalHours': json['totalHours'],
        'hourlyRate': BalanceUnitStatementEntryDebitFromJSON(json['hourlyRate']),
        'amount': BalanceUnitStatementEntryDebitFromJSON(json['amount']),
        'approvedAt': (json['approvedAt'] == null ? null : new Date(json['approvedAt'])),
        'approvedBy': json['approvedBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
        'timeEntryType': GetTimeEntryTypeBaseResponseFromJSON(json['timeEntryType']),
        'appointment': GetAppointmentBaseResponseFromJSON(json['appointment']),
    };
}

export function GetPayrollLedgerEntryResponseToJSON(json: any): GetPayrollLedgerEntryResponse {
    return GetPayrollLedgerEntryResponseToJSONTyped(json, false);
}

export function GetPayrollLedgerEntryResponseToJSONTyped(value?: GetPayrollLedgerEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'approvalDate': value['approvalDate'].toISOString().substring(0,10),
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'workDate': value['workDate'].toISOString().substring(0,10),
        'totalHours': value['totalHours'],
        'hourlyRate': BalanceUnitStatementEntryDebitToJSON(value['hourlyRate']),
        'amount': BalanceUnitStatementEntryDebitToJSON(value['amount']),
        'approvedAt': value['approvedAt'] == null ? value['approvedAt'] : value['approvedAt'].toISOString(),
        'approvedBy': value['approvedBy'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'timeEntryType': GetTimeEntryTypeBaseResponseToJSON(value['timeEntryType']),
        'appointment': GetAppointmentBaseResponseToJSON(value['appointment']),
    };
}

